import { ImageCaptionDTO, RawImageCaption } from './api.types';

export type CapacityMode = 'ENUMERATED' | 'POOLED' | 'SINGLE_BERTH_POOL';
export type PierContentLanguage = 'fi' | 'sv' | 'en' | 'de';
export type PierContentTranslations = Partial<Record<PierContentLanguage, string | null>>;

export interface IPierData {
  id: string;
  name: string;
  harbor_id: string;
  boater_label?: string;
  approach_note?: string;
  boater_label_translations?: PierContentTranslations | null;
  approach_note_translations?: PierContentTranslations | null;
  capacity_mode?: CapacityMode;
  pooled_capacity?: number;
  image?: string | null;
  image_captions?: RawImageCaption[] | null;
  harbor?: {
    id: string;
    name: string;
  };
  berths?: {
    id: string;
    berth_number: string;
  }[];
}

export interface PierListQueryParams {
  search?: string;
  harbor_id?: string;
  page?: number;
  limit?: number;
}

export interface PierApiResponse {
  id: string;
  name: string;
  harbor_id: string;
  image?: string | null;
  image_captions?: RawImageCaption[] | null;
  berths?: {
    id: string;
    berth_number: string;
  }[];
}

export interface CreatePierPayload {
  name: string;
  harbor_id: string;
  boater_label?: string | null;
  approach_note?: string | null;
  boater_label_translations?: PierContentTranslations | null;
  approach_note_translations?: PierContentTranslations | null;
  capacity_mode?: CapacityMode;
  pooled_capacity?: number;
}

export interface UpdatePierPayload {
  name: string;
  harbor_id: string;
  pierId: string;
  boater_label?: string | null;
  approach_note?: string | null;
  boater_label_translations?: PierContentTranslations | null;
  approach_note_translations?: PierContentTranslations | null;
  capacity_mode?: CapacityMode;
  pooled_capacity?: number;
}

/** Converts the API's { image_index, translations } shape into the { image_index, captions } shape the form/upload payload uses. */
export const rawImageCaptionsToDto = (
  raw?: RawImageCaption[] | null
): ImageCaptionDTO[] | undefined =>
  raw?.length
    ? raw.map((item) => ({ image_index: item.image_index, captions: item.translations }))
    : undefined;

export interface IPierFormData {
  name: string;
  harbor_id: string;
  boater_label?: string;
  approach_note?: string;
  boater_label_translations?: PierContentTranslations | null;
  approach_note_translations?: PierContentTranslations | null;
  capacity_mode?: CapacityMode;
  pooled_capacity?: number;
  /** undefined = untouched, string = existing stored URL, File = newly staged for upload, null = marked for removal */
  image?: File | string | null;
  /** Caption (per-language) and copyright for the pier image; a single entry at image_index 0 */
  image_captions?: ImageCaptionDTO[];
  harbor?: {
    id: string;
    name: string;
  };
}
